import createIcon from './createIcon';

export default createIcon(require('./local_shipping.svg'));